import { render, staticRenderFns } from "./PqrsComercial.vue?vue&type=template&id=5d8ce114&scoped=true"
import script from "./PqrsComercial.vue?vue&type=script&lang=js"
export * from "./PqrsComercial.vue?vue&type=script&lang=js"
import style0 from "./PqrsComercial.vue?vue&type=style&index=0&id=5d8ce114&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8ce114",
  null
  
)

export default component.exports